declare namespace $ {

	export class $mol_icon_application_brackets extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=brackets.view.tree.d.ts.map